import { useContext } from "react";
import FieldActionsContext from "./FieldActionsContext";
const DEFAULT_CONTEXT_VALUE = {
  evaluateCondition: (conditionFn, handlerArgs) => conditionFn(handlerArgs),
  additionalHandlerArgs: {},
  valueActions: [],
  fieldActions: []
};
const useFieldActions = () => {
  const contextValue = useContext(FieldActionsContext);
  if (!contextValue) {
    return DEFAULT_CONTEXT_VALUE;
  }
  return contextValue;
};
export default useFieldActions;
